import { makeStyles } from '@material-ui/styles';
import { white, royalBlueDark } from '../../../constants/Colors';

export default makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #e3e3e3',
        padding: '15px 40px',
        background: white,
    },
    content: {
        width: 500,
        display: 'flex',
        flexDirection: 'column',
    },
    input: {
        width: '100%',
        border: 'none',
        margin: '3px 3px 3px 0',
        outline: 'none',
        padding: '8px 30px 8px 8px',
        fontSize: 15,
        boxSizing: 'border-box',
        fontWeight: 300,
    },
    button: {
        marginLeft: 5,
        padding: '6px 24px',
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    buttons: {},
    formControl: {
        marginTop: 20,
        marginBottom: 10,
        display: 'block',
        '& *': {
            margin: 0,
        },
    },
    connectionTypes: {
        display: ({ isConnectionShown }) => (isConnectionShown ? 'block' : 'none'),
    },
    radioField: {
        marginLeft: 17,
        fontSize: '15px',

        '& label': {
            marginRight: 0,
        },
    },
    linkedinInputContainer: {
        position: 'relative',
        marginTop: 8,
    },
    linkedinInput: {
        width: '100%',
        '& input': {
            color: '-webkit-link',
            textDecoration: 'underline',
        },
    },
    linkedinUrl: {
        cursor: 'pointer',
        position: 'absolute',
        top: 25,
        left: 8,
        height: 20,
        maxWidth: 440,
    },
}));
